/** @jsx isolateComponent */
import { useState } from 'react';
import { isolateComponent } from '@zapier/style-encapsulation';

import { Alert, AlertDescription } from '@zapier/design-system';
import { useSwitch } from '@zapier/toolbox-ab-testing';

// A reusable component that can be used to display an informational
// banner to customers when they are viewing the contact form.
// For example: reduced availability of support during holidays or due to system problems.
export const ContactFormAlertBanner = () => {
  const [showBanner, setShowBanner] = useState(true);
  const { isSwitchOn } = useSwitch('showContactFormAlertBanner');

  if (isSwitchOn && showBanner) {
    return (
      <Alert
        ariaLive="polite"
        hasShadow={true}
        layout="box"
        onDismiss={() => {
          setShowBanner(false);
        }}
        type="warning"
      >
        <AlertDescription>
          Zapier will be participating in a company retreat May 9th to May 13th.
          During this time you may experience extended response times.
        </AlertDescription>
      </Alert>
    );
  } else {
    return null;
  }
};
